import sanitizeHtml from 'sanitize-html'

export default (html = '') => sanitizeHtml(html, {
    allowedTags: ['br', 'span'],
    allowedAttributes: {
        span: ['style'],
    },
})
